<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Where is my book?</h1>

			<v-base-nav-page :links="links" :nosearch="true" v-if="!loading && !is_local_pickup && !is_ia_item">
			</v-base-nav-page>

			<div v-if="!loading && is_local_pickup && !is_ia_item">
				<p>This is a local pickup item, you should go to the following pickup location:</p>
				<p v-if="lp_address">
					<strong>{{ lp_address['name'] }}</strong><br>
					<strong>{{ lp_address['line1'] }}</strong><br>
					<strong>{{ lp_address['city'] }}, {{ lp_address['state'] }} {{ lp_address['postal_code'] }}</strong>
				</p>
				<p>If you have already been to the location and are having an issue, please let us know below.</p>

				<div class="h-email-form">
					<email-form
							caption="Email us"
							subject="I have an issue with my Local Pickup Item"
							:body="getBody()"
							on-success-url="/help?#/submitted"
							edit-body
							must-edit
							:payload="{order_line_id}"
							destination-key="cs"
					></email-form>
				</div>
			</div>

			<p v-if="!loading && is_ia_item">
				This item is an {{ inclusive_access_name }} item and will be added to your LMS (i.e. blackboard, etc) and will be available to you starting from <strong>{{ ia_provisioning_date }}</strong> automatically. It will also be added to your eLibrary on this date.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import Axios from 'axios';
	import BaseNavPage from './../../components/BaseNavPage';
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "WhereIsMyBook",

		components: {
			'v-base-nav-page': BaseNavPage,
			BaseNavLinks,
			EmailForm
		},

		data() {
			return {
				links: [
					{
						to: '/when_will_book_ship/' + parseInt(this.$route.params.id),
						caption: 'When will my item ship?'
					},
					{
						to: '/missing_item/' + parseInt(this.$route.params.id),
						caption: 'I’m missing an item'
					},
					{
						to: '/tracking_delivered/' + parseInt(this.$route.params.id),
						caption: 'Tracking says delivered but I haven’t received it'
					},
					{
						to: '/tracking_returned/' + parseInt(this.$route.params.id),
						caption: 'Tracking shows my book was returned because of a delivery issue'
					},
					{
						to: '/tracking_stopped_moving/' + parseInt(this.$route.params.id),
						caption: 'My package seems to have stopped moving'
					},
				],
				loading: false,
				order_line_id: null,
				is_local_pickup: false,
				is_ia_item: false,
				ia_provisioning_date: '',
				lp_address: null
			}
		},

		mounted() {
			const self = this;

			self.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						if (
							!_.isUndefined(response['data']['data']['is_inclusive_access_item'])
							&& response['data']['data']['is_inclusive_access_item'] == true
						) {
							self.is_ia_item = true;
							self.ia_provisioning_date = response['data']['data']['delivery_date'];
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});

			self.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(this.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						if (!_.isUndefined(response.data['data']['is_local_pickup'])) {
							self.order_line_id = response.data['data']['order_line_id'];
							self.is_local_pickup = response.data['data']['is_local_pickup'];
							self.lp_address = response.data['data']['local_pickup_address'];
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		methods: {
			getBody() {
				return "My local pickup item had an issue. The issue was:\n\n\n\n\n";
			},
		},

		computed: {
			inclusive_access_name() {
				return this.$globs.institute_info.inclusive_access_name;
			},
		}
	}
</script>

<style scoped>

</style>